import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";
import { Mic, Trash2, LogIn, Info } from "lucide-react";

export default function Header({
    restaurant,
    table,
    onOpenVoice,
    onReset,
    onOpenInstructions,
    styles,
}) {
    const navigate = useNavigate();
    const location = useLocation();
    const { authenticated, logout } = useAuth();

    const handleAuthAction = () => {
        if (authenticated) {
            logout();
        } else {
            // Save current URL to return after login
            localStorage.setItem('returnUrl', location.pathname);
            navigate("/register");
        }
    };

    return (
        <div style={styles.header}>
            <div style={styles.headerLeft}>
                <div style={styles.title}>
                    {restaurant?.name || "Restaurant"} (Стіл {table})
                </div>
                <div style={styles.subtitle}>
                    {restaurant?.address || ""}
                </div>
            </div>

            <div style={styles.headerRight}>
                <button onClick={onOpenVoice} style={styles.smallBtn} title="Голос">
                    <Mic size={20} />
                </button>

                <button onClick={onOpenInstructions} style={styles.smallBtn} title="Інструкції">
                    <Info size={20} />
                </button>

                <button onClick={onReset} style={styles.smallBtn} title="Очистити">
                    <Trash2 size={20} />
                </button>

                {!authenticated && (
                    <button onClick={handleAuthAction} style={styles.smallBtn} title="Увійти">
                        <LogIn size={20} />
                    </button>
                )}
            </div>
        </div>
    );
}
